<template>
  <div class="container_aboutme">
    <div class="banner"></div>
    <div class="container">
      <div class="brief">
       嘉信保险经纪有限公司(原名:北京嘉信保险经纪有限公司，简称:嘉信保险)始创于2005年，是由中国保监会批准成立的首批的全国专业保险中介公司。 砥砺发展13年后，2018年公司调整战略，由北京迁到广东省广州市，加快国内布局，着眼世界市场。 公司秉承“诚信为本、服务至上;合作共赢、追求卓越"的理念 ，始终以客户需求为导向，不断深耕市场、锐意创新，不断求真务实、大胆开拓，乘大数据时代发展之势，力求把专业做到极致。
      </div>
      <div class="history">
        <h3>公司大事记</h3>
        <template>
          <Timeline class="self_timeLine">
            <TimelineItem v-for="item in timelineData" :key="item.id">
              <p class="time">{{item.time}}</p>
              <p class="content">{{item.event}}</p>
            </TimelineItem>
          </Timeline>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
var timelineData = [{
  id: 1,
  time: '2005年06月',
  event: '北京嘉信保险经纪公司成立'
},{
  id: 2,
  time: '2006年01月',
  event: '嘉信保险成为中国保险报业集团董事会会员单位'
},{
  id: 3,
  time: '2009年01月',
  event: '嘉信保险成立嘉信保险广东分公司'
}, {
  id: 4,
  time: '2013年07月',
  event: '嘉信保险获批成为全国性保险中介牌照'
}, {
  id: 5,
  time: '2014年03月',
  event: '嘉信保险客户数量累积达15万'
},  {
  id: 6,
  time: '2017年10月',
  event: '北京嘉信保险经纪公司更名为嘉信保险经纪有限公司'
}, {
  id: 7,
  time: '2017年10月',
  event: '嘉信保险成立嘉信保险山东分公司'
},{
  id: 8,
  time: '2018年06月',
  event: '嘉信保险经纪有限公司总部由北京迁到广东省广州市，加快全国市场布局'
}]

export default {
  name: "index",
  data() {
    return {
      timelineData: timelineData
    }
  }
}
</script>
<style scoped lang="less" src="../../style/index.less"></style>
<style scoped lang="less">
@media screen and (min-width: 768px) {
  .container_aboutme {
    .banner {
      height: 400px;
      background: url(../../assets/aboutme.jpg) no-repeat;
      background-size: cover;
    }
    .container {
      .brief {
        font-size: 16px;
        padding: 50px 130px;
        background-color: #ffffff;
        color: #333333;
        position: relative;
        top: -100px;
        z-index: 10;
        line-height: 32px;
        box-shadow: 1px 1px 5px 2px #cccccc;
      }
      .history {
        h3 {
          font-size: 24px;
          padding: 20px 20px 10px;
          border-bottom: 1px solid #eaeaea;
        }
        .self_timeLine {
          padding: 30px 75px;
          .time {
            color: #666666;
            font-size: 16px;
            margin-bottom: 10px;
          }
          .content {
            font-size: 18px;
            color: #333333;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
  //
  .container_aboutme {
    padding-top: 44px;
    .banner {
      height: 125px;
      background: url(../../assets/m_aboutme.png) no-repeat;
      background-size: cover;
    }
    .container {
      transform: translate(0, -120px);
      .brief {
        font-size: 14px;
        width: 86%;
        background-color: #ffffff;
        color: #333333;
        padding: 20px;
        border-radius: 10px;
        position: relative;
        left: 50%;
        margin-left: -43%;
        z-index: 10;
        line-height: 32px;
        box-shadow: 1px 1px 5px 2px #cccccc;
      }
      .history {
        h3 {
          padding: 20px 20px 10px;
          border-bottom: 1px solid #eaeaea;
          font-size: 14px;
        }
        .self_timeLine {
          padding: 30px 75px;
          .time {
            color: #666666;
            font-size: 14px;
            margin-bottom: 10px;
          }
          .content {
            font-size: 14px;
            color: #333333;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/Aboutme/index.vue